import axiosInstance from '../../../config/axiosInstance';
import { SaleOrderPaymentValidation } from "../View/Validation/SaleOrderPaymentValidation";

const handleChange = (event, formData, setFormData) => {
  const { name, value } = event.target;
  setFormData({
    ...formData,
    [name]: value,
  });
};

const handleSubmit = async (event, formData, setFormData, setErrors,redirectCallback,redirectRoleList) => {
 
  event.preventDefault();
  const formErrors = SaleOrderPaymentValidation(formData);
  setErrors(formErrors);
  if (Object.keys(formErrors).length === 0) {
    try {
      const CompanyID=localStorage.getItem("CompanyID");
      formData.ClientID=CompanyID;
      const UserID=localStorage.getItem("UserID");
      formData.UserID=UserID;
      const response = await axiosInstance.post(`/SaleOrder/CreateSaleOrderPayment`, formData);
      redirectRoleList();
    } catch (error) {
      console.error('Error posting data:', error);
    }
  }
};

export { handleChange, handleSubmit };